import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";
import { Header } from "@/components/Header";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Lock } from "lucide-react";

function formatApiErrorDetail(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { t } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("pv_token")) {
      api.get("/auth/me").then(() => navigate("/admin/dashboard")).catch(() => localStorage.removeItem("pv_token"));
    }
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("pv_token", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <Header />
      <div className="max-w-md mx-auto px-5 py-24">
        <div className="border border-[color:var(--c-ink)] bg-[color:var(--c-bg)] p-8">
          <span className="w-12 h-12 flex items-center justify-center bg-[color:var(--c-dark)] text-[color:var(--c-on-dark)] mb-6">
            <Lock size={20} strokeWidth={1.5} />
          </span>
          <h1 className="font-serif text-4xl">{t("admin_login")}</h1>
          <form onSubmit={submit} className="space-y-4 mt-8">
            <Input data-testid="admin-email" type="email" required placeholder={t("email")}
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="rounded-none bg-[color:var(--c-surface)] border-[color:var(--c-border)] h-12" />
            <Input data-testid="admin-password" type="password" required placeholder={t("password")}
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="rounded-none bg-[color:var(--c-surface)] border-[color:var(--c-border)] h-12" />
            <button data-testid="admin-login-button" type="submit" disabled={loading}
              className="w-full bg-[color:var(--c-dark)] text-[color:var(--c-on-dark)] hover:bg-[color:var(--c-accent)] transition-colors py-3 text-sm tracking-[0.2em] uppercase font-semibold disabled:opacity-60">
              {loading ? "…" : t("login")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
